import { FacilitySortOption } from '@rematter/frontend-lib-api-client';

import { ObjectRefRecord } from '~/shared/components/custom-attributes/types';
import { createQueryHook } from '~/shared/providers/api';

export const useFacilitiesQuery = createQueryHook(
  'facilities.facilities',
  (params: {
    searchTerm?: string;
    sorting?: FacilitySortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    facilities: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        facilityName: true,
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): ObjectRefRecord[] =>
      data?.facilities.entries.map((facility) => ({
        id: facility.id,
        name: facility.facilityName,
      })) ?? [],
  },
);
